import React, { Fragment } from "react";
import { CardElement } from "react-stripe-elements";
import cn from "classnames";
import { Type } from "discover.medical.react-component-library";

const PaymentInformation = ({ onBlur, onChange, showCardError }) => {
  return (
    <Fragment>
      <Type element="h2" styledAs="h3" fontFamily="secondary" marginBottom="sm">
        Payment Information
      </Type>
      <div className="form-group">
        <label htmlFor="stripe-card-element">Credit or Debit Card Number</label>
        {showCardError && (
          <span className="form-group__required-field">*Required</span>
        )}
        <CardElement
          onBlur={onBlur}
          onChange={onChange}
          className={cn("form-control", {
            danger: showCardError,
          })}
          style={{
            base: {
              fontSize: "14px",
              fontFamily: "Arial",
            },
          }}
          id="stripe-card-element"
        />
      </div>
    </Fragment>
  );
};

export default PaymentInformation;
